import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-date-day',
  templateUrl: './date-day.component.html',
  styleUrls: ['./date-day.component.scss']
})
export class DateDayComponent implements OnInit {

 

  @Input('jobs') jobs;
  constructor(private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.changeDetector.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log("changes in day-date", changes)
    if(changes.jobs){
      this.jobs = changes.jobs.currentValue
      // console.log("VALUE ASSIGNED", this.jobs)
      this.changeDetector.detectChanges();
    }
  }

}
